// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__24P-L","col":"Table_col__11zBM","fulfillmentStatus":"Table_fulfillmentStatus__3_510","emailCol":"Table_emailCol__2ITMJ"};